import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../stores/hooks";
import {  OutputTableInfo, SplitMenuItem } from "../../data/interfaces/sharedmodels";
import {
     Box, Avatar, List, ListItemButton,
     ListItemText,  ListItemAvatar, Card, CardContent, CardHeader, TextField, Button, Checkbox, ListItem, FormControlLabel,
     Typography,
     ListItemIcon
} from "@mui/material";
import { TableChart as TableViewIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { updateselectedoutputtable as updatemagneticselectedtable ,updateselectedoutputtables as updateMagneticSelectedoutputtables,
    updateBuildTableStep as updateMagneticBuildTableStep} from "../../stores/magneticslice";
import { updateselectedoutputtable as updateitsoselectedtable ,updateBuildTableStep as updateItsoBuildTableStep,
    updateselectedoutputtables as updateItsoSelectedoutputtables} from "../../stores/itsoslice";
import SplitButton from "../splitbutton";


export default function OutputTables({ parent, tables }: { parent: string, tables: OutputTableInfo[] }) {
    const dispatch = useAppDispatch();
    const [allChecked, setAllChecked] = useState<boolean>(false);
    const [globalChecked, setGlobalChecked] = useState<boolean>(false);
    const [stationSpecificChecked, setStationSpecificChecked] = useState<boolean>(false);
    const [filteredTables, setFilteredTables] = useState<OutputTableInfo[]>(tables);
    const selectedTable = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedOutputTable; }
        else { return state.itsoReducer.selectedOutputTable; }
    });
    const selectedOutputTables = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedOutputTables; }
        else { return state.itsoReducer.selectedOutputTables; }
    });
    const selectedOutputNlcs = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedOutputNlcs; }
        else { return state.itsoReducer.selectedOutputNlcs; }
    });


    useEffect(()=>{
        setFilteredTables(tables);
        setAllChecked(selectedOutputTables.length === tables.length);
        setGlobalChecked(selectedOutputTables.filter(a=>a.IsGlobal).length==tables.filter(a=>a.IsGlobal).length);
        setStationSpecificChecked(selectedOutputTables.filter(a=>!a.IsGlobal).length==tables.filter(a=>!a.IsGlobal).length);
    },[tables])
    
    //select the first item as default
    useEffect(() => {
        if (tables.length > 0) {
            if (parent === 'magnetic') {
                dispatch(updatemagneticselectedtable(tables[0]));
            }
            else {
                dispatch(updateitsoselectedtable(tables[0]));
            }
        }
    }, [])

    //listens to changes in selected build table to handle all checkbox item status.
    useEffect(() => {
        setAllChecked(selectedOutputTables.length === tables.length);
        setGlobalChecked(selectedOutputTables.filter(a=>a.IsGlobal).length==tables.filter(a=>a.IsGlobal).length);
        setStationSpecificChecked(selectedOutputTables.filter(a=>!a.IsGlobal).length==tables.filter(a=>!a.IsGlobal).length);
    }, [selectedOutputTables]);

    //handle the select all checkbox
    const handleAllChecked = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
            if (parent === 'magnetic') {
                dispatch(updateMagneticSelectedoutputtables(event.target.checked? tables:[]));
            }
            else {
                dispatch(updateItsoSelectedoutputtables(event.target.checked? tables:[]));
            }
    };

    const handleAllGlobalChecked = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
            if (parent === 'magnetic') {
                dispatch(updateMagneticSelectedoutputtables(event.target.checked? [ ...tables.filter(a=>a.IsGlobal), ...selectedOutputTables.filter(a=>!a.IsGlobal)]:selectedOutputTables.filter(a=>!a.IsGlobal)));
            }
            else {
                dispatch(updateItsoSelectedoutputtables(event.target.checked? [ ...tables.filter(a=>a.IsGlobal), ...selectedOutputTables.filter(a=>!a.IsGlobal)]:selectedOutputTables.filter(a=>!a.IsGlobal)));
            }
    };

    const handleAllStattionSpecificChecked = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
            if (parent === 'magnetic') {
                dispatch(updateMagneticSelectedoutputtables(event.target.checked? [ ...tables.filter(a=>!a.IsGlobal), ...selectedOutputTables.filter(a=>a.IsGlobal)]:selectedOutputTables.filter(a=>a.IsGlobal)));
            }
            else {
                dispatch(updateItsoSelectedoutputtables(event.target.checked? [ ...tables.filter(a=>!a.IsGlobal), ...selectedOutputTables.filter(a=>a.IsGlobal)]:selectedOutputTables.filter(a=>a.IsGlobal)));
            }
    };

    //handle the select on table item
    const handleListItemClick = (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>,
        table: OutputTableInfo,
    ) => {
        if (parent === 'magnetic') {
            dispatch(updatemagneticselectedtable(table));
        }
        else {
            dispatch(updateitsoselectedtable(table));
        }

    };
    
    //handle the filter value change
    const onFilterChnage = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {

        const filtertables = [...tables].filter(a => a.Description.toLowerCase().includes(event.target.value.toLowerCase()) ||
            a.Name.toString().toLowerCase().includes(event.target.value.toLowerCase()));
        setFilteredTables(filtertables);

    };

    const handleToggle = (table: OutputTableInfo) => () => {
        const currentIndex = selectedOutputTables.findIndex(a => a.Id == table.Id);
        const newChecked = [...selectedOutputTables];

        if (currentIndex === -1) {
            newChecked.push(table);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        if (parent === 'magnetic') {
            dispatch(updateMagneticSelectedoutputtables(newChecked));
        }
        else {
            dispatch(updateItsoSelectedoutputtables(newChecked));
        }
    };
    const handlePdfExport = () => {
        alert('pdf');
    };
    const handleExcelExport = () => {
        alert('Excel');
    };
    const handleBuild=()=>{      
        if (parent === 'magnetic') {
            dispatch(updateMagneticBuildTableStep(1));
        }
        else {
            dispatch(updateItsoBuildTableStep(1));
        }
    }
    const menus: SplitMenuItem[] = [{ Description: 'As PDF', CallBackFn: { handlePdfExport } },
    { Description: 'As Excel', CallBackFn: { handleExcelExport } }]
    return (
        <Card>
            <CardHeader title={
                <Box>
                    <Box sx={{display:'flex',mb:1}}>
                    <Avatar sx={{ backgroundColor: 'primary.main' }}>
                                                        <TableViewIcon />
                                                    </Avatar>

                    <Typography variant="h6" sx={{ml:2}}>Output Tables</Typography>                          
                    </Box>
                <TextField label="Filter Output Tables" sx={{ width: '100%' }} size="small" onChange={onFilterChnage} />
                </Box>} />
            <CardContent sx={{ pt: 0 }}>
                <Box sx={{ display: 'inline-block', width: '100%' }}>
                    <Button disabled={selectedOutputTables.length<1 ||(selectedOutputTables.findIndex(a=>!a.IsGlobal)>-1&&selectedOutputNlcs.length<1 )} variant="contained" sx={{ width:'100%',mb:1 }} onClick={handleBuild}>Build Selected</Button>
                    {/* <SplitButton menuHeader="Export Selected" menus={menus} maxwidth="100%"/> */}
                </Box>
                <Box sx={{display:'flex',pl:2.5,bgcolor:'#efefef'}}>
                <FormControlLabel sx={{display:'flex', justifyContent:'end'}} labelPlacement="end" 
             control={<Checkbox sx={{p:0.5}} checked={globalChecked} onChange={handleAllGlobalChecked}/>} label="Global"  />
             <FormControlLabel sx={{display:'flex', justifyContent:'end'}} labelPlacement="end" 
             control={<Checkbox sx={{p:0.5}} checked={stationSpecificChecked} onChange={handleAllStattionSpecificChecked}/>} label="Station Specific" />
             <FormControlLabel sx={{display:'flex', justifyContent:'end'}} labelPlacement="end" 
             control={<Checkbox sx={{p:0.5}} checked={allChecked} onChange={handleAllChecked}/>} label="All" /></Box>
                <List dense={true} >
                    {
                        filteredTables.map(function (table) {
                            return (
                                <ListItem key={table.Id}
                                    disablePadding>
                                    <ListItemButton  selected={selectedTable?.Id === table.Id}
                                        onClick={(event) => handleListItemClick(event, table)}>
                                            <ListItemIcon>
                                            <Checkbox
                                            edge="start"
                                            checked={selectedOutputTables.findIndex(a => a.Id == table.Id) > -1}
                                            tabIndex={-1}
                                            disableRipple
                                            onChange={handleToggle(table)}
                                            inputProps={{ 'aria-labelledby': table.Description }}
                                        />
                                            </ListItemIcon>
                                        <ListItemText primary={table.Name + ' - ' + table.Description} secondary={table.LastUpdated} />
                                    </ListItemButton></ListItem>)
                        })
                    }
                </List>
            </CardContent>
        </Card>

    );
}